export default function MySQL_RAND() {
  return (
    <div>
      <h2>MySQL_RAND</h2>    </div>
  );
}